<template>
    <div :class="['item-preview','item-'+size]">
    <!-- <transition name="fadeLeft"> -->
        <!--
        <div v-if="!!item.flag" class="item-flag"><img :src="item.flag" alt=""></div>
        -->
        <div class="item-flag" v-if="item.lang.length>0 && item.lang!='EN'">
            <img :src="`static/img/flags/${item.lang}.png`" alt="">
        </div>
        <!-- </transition>  -->
        <!-- !!item.inCart && type==='result' ? 'incart' : '' -->

        <div :class="['item-preview-image', 
        'bordermode-'+settings.borderMode,
        'item-'+size, 
                    !!showActionsOnDevices ? 'active' : '', 
                    !!isThisitemInLimbo ? 'flyin' : '',                     
                ]"                    
        :style="previewImageStyle"
        :draggable="draggable"
        @dragstart="dragStart"
        @dragend="dragEnd"
        @touchend.passive="toggleActionsForDevices($event)"
        @touchmove.passive="toggleActionsForDevices($event)">
            <div v-if="!!actions.length" :class="['item-actions','bordermode-'+settings.borderMode,]">
                <div class="item-act-title font-small">
                    {{item.catNo}}<br/>
                    {{item.name}}
                </div>
                <!-- v-if="(!adding && !item.inCart) || type==='cart'" -->

                <button                    
                    v-for="action in actions"
                    class="action"
                    @click.prevent="actionHandler(action)"
                    :key="action">
                        <i :class="['icon-'+action]"></i>
                        <span> {{ labelFor(action) }} </span>
                </button>


                <transition name="fade-down-blast" appear>
                    <div v-if="adding" key="addItem" class="item-add">
                        <button @click="adding=false" class="closebtn"></button>
                        <label :for="`itemAdd-${item.id}`">Amount of items:</label>
                        <input :id="`itemAdd-${item.id}`" @keydown="amountChangeHandler" @focus="focusHandler" @blur="blurHandler" min="1" v-model.number="amount" type="number">
                        <button @click="addItem(item)" class="check--save">
                            <i class="checkbtn"></i>
                        </button>
                    </div>
                    <!--
                    <div v-if="!adding && item.inCart && type!=='cart'" key="incart" class="item--incart" title="You can change amount of items">
                        <button @click="removeFromCart(item)" class="closebtn" title="Remove item from cart"></button>
                        <i class="fas fa-cart-plus"></i>
                        <input :id="`itemAdd-${item.id}`" @keydown="amountChangeHandler($event, true)" @focus="focusHandler" @blur="blurHandler" min="1" v-model.number="amount" type="number">
                        <label :for="`itemAdd-${item.id}`"> Items in cart</label>
                        <transition name="fade-down" appear>
                            <button v-if="updating" @click="updateItem(item)" class="check--save">
                                <i class="checkbtn"></i>
                            </button>
                        </transition>
                    </div>
                    -->
                </transition>
            </div>
            <div class="item-info" v-if="!!info">
                <div class="info" v-text="item.amount + (item.amount<2 ? ' item' : ' items')"></div>
            </div>
        </div>
        <div class='label font-small'>
            <!-- ppp= {{item.id}} === -->
            <div class="item-mct">{{item.catNo}}</div>
            <div class="item-name">{{item.name}}</div>
        </div>
    </div>
</template>
<script>
import { selectText } from '../../utils';
import { mapState, mapActions } from 'vuex';
export default {
    props: ['type', 'info', 'item', 'size', 'actions', 'draggable'],
    mounted() {
        // console.log("item prev mounted", this.imgfail,this.addingtimer);
        if (!!this.item.amount) {
            this.amount = this.item.amount;

        }
    },
    data() {
        return {
            // quantfocus:false,
            _img: null,
            blurtimer: -1,
            amount: 1,
            adding: false,
            updating: false,
            showActionsOnDevices: false,
            btnClickDisabler: false,
            inSwipeScroll: false,
            defaultItemBg: '/img/ImageNot.svg',
            resolver: null,
            imgfail: false,
            addingtimer: -1
        }
    },
    methods: {
        blurHandler() {
            this.amountFieldInFocus = false;
            this.blurtimer = setTimeout(function() {
                this.blurUpdate();
            }.bind(this), 1500)
        },
        blurUpdate(e) {
            !!e && e.target.blur();
            this.updating = false;
            if (!!this.item.amount) {
                this.amount = this.item.amount;
            }
        },
        focusHandler(e) {
            // console.log('fcous');
            e.target.select()
            this.amountFieldInFocus = true;
            clearTimeout(this.blurtimer);
            clearTimeout(this.addingtimer);
        },
        amountChangeHandler(e, updating) {
            // console.log("updating?? ", updating);

            if (e.keyCode===13) {
                if (!!updating) {
                    this.updateItem();
                }
                else {
                    this.addItem();
                }
                e.target.blur()
            }
            else if (e.keyCode===27) {
                this.blurUpdate(e);
            }
            else if (!!updating) {
                this.updating = true;
            }
        },
        addToCartAskAmount(item) {
            //opt1: this will directly add the item
            this.addItem(item);

            //opt2: this will show the input amount before adding the item
/*             this.adding = true;
            this.addingtimer = setTimeout(function() {
                this.adding = false
            }.bind(this), 5000)
 */        
        },
        addItem(item) {
            let _item = item || _.clone(this.item)
            _item.amount = this.amount;
            let _data = { item: _item, dontShowCart: true }
            this.addToCart(_data);
            this.adding = false;
        },
        toggleActionsForDevices(e) {
            if (e.type==='touchmove') {
                this.$set(this, 'inSwipeScroll', true);
            }
            else {
                if (!this.inSwipeScroll) {
                    if (!!this.isTouchDevice) {
                        setTimeout(function() {
                            this.showActionsOnDevices = !this.showActionsOnDevices;
                        }.bind(this),100)
                    }

                }
                this.$set(this, 'inSwipeScroll', false);
            }

        },
        updateItem(item=this.item) {
            let _item = _.clone(item)
            _item.amount = this.amount;
            this.updateItemInCart({ item:_item, dontShowCart: true });
            this.updating = false;
        },
        labelFor(action) {
            switch(action) {
                case 'open':
                case 'view':
                    return this.type==='cart' ? '' : (this.isTouchDevice ? 'Details' : 'Show Details');
                case 'plus':
                    //return 'Add to Cart';
                    return 'Add to List';
                case 'images':
                    return 'Go to Images';
                default:
                    return '';
            }
        },
        actionHandler(action) {
            if (!this.btnClickDisabler) {
                this.$set(this, 'btnClickDisabler', true);
                switch(action) {
                    case 'open':
                    case 'view':
                        let item = _.clone(this.item);
                        
                        //console.log("++++this.item="+this.item);

                        ///alert(this.item);

                        item.editmode = this.type==='cart';
                        this.openItem(item);
                        break;
                    case 'plus':
                        this.addItem(this.item);
                        //bug
                        //fade need to be removed 
                        //this.addToCartAskAmount(this.item);
                        //this.addToCart(this.item);
                        break;
                    case 'remove':
                        this.$emit('onCartItemRemoved');
                        this.removeFromCart(this.item);
                        break;
                    default:
                        return '';
                }
                setTimeout(()=> {
                    this.$set(this, 'btnClickDisabler', false);
                }, 300)
            }
        },
        dragStart(e) {
            if (this.amountFieldInFocus) {
                e.preventDefault();
            } else {
                this.updateItemInLimbo(this.item);
            }
        },
        dragEnd(e) 
        {
            if (e.pageY<document.querySelector(".cartSection").getBoundingClientRect().bottom) {
                this.addToCart({ item:this.item } );
            }
            this.updateItemInLimbo(null);
        },
        removeListeners(el) {
            el.removeEventListener('load', this.imgLoaded);
            el.removeEventListener('error', this.imgError);
        },
        imgLoaded(err,res) {
            // console.log("IMG LOADED > ", this.item.image);
            this.resolver('background-image:url('+this.item.image+')')
            this.removeListeners(this._img)
            this.resolver = null;
            this._img = null;
            this.imgfail = false;
        },
        imgError(err) {
            // console.log("IMG ERROR > ", this.item.image);
            // if (!this.imgfail) {
            //     let img = this.item.image.replace("/static", "")
            //     this.$set(this.item, 'image', img);
            //     // console.log("2 IMG ERROR > ", this.item.image);
            //     this.rejecter()
            //     this.resolveImg(this.item.image)
            //     // this._img.src = this.item.image;

            // } else {
                // console.log('halo resolve default bg.. ', this.resolver, " :: ", this.item.image);
                this.resolver('background-image:url('+this.defaultItemBg+'); background-size: 50%')
                this.removeListeners(this._img)
                this.resolver = null;
                this._img = null;
            // }
            // this.imgfail = true;
        },
        async resolveImg(img) {
            var vm = this,
            //src = img || vm.item.image;
            src = vm.item.image;
            // console.log("RESOLVE IMG > ", src);
            return new Promise((resolve,reject) => {
                // console.log("1 Promise IMG > ", vm._img ," :: ", src);
                vm.resolver = resolve;
                vm.rejecter = reject;
                if (!vm._img) {
                    vm._img = document.createElement('img');
                    vm._img.addEventListener('load', vm.imgLoaded);
                    vm._img.addEventListener('error', vm.imgError);
                }
                // console.log("2 Promise IMG > ", vm._img ," :: ", src);
                vm._img.src = src;
            }).catch(e => {
                vm.resolver('background-image:url('+this.defaultItemBg+'); background-size: 50%')
                // console.log('caught promise error>> ', src, " : resolver :: ", vm.resolver );
            })
        },
        ...mapActions([
            'addToCart',
            'openItem',
            'removeFromCart',
            'updateItemInCart',
            'showShelf',
            'updateItemInLimbo'
        ])
    },
    asyncComputed: {
        async previewImageStyle() 
        {
            return "background-image:url('https://market.mis-implants.com"+this.item.image+"')";
            //return 
/*             return new Promise(async (resolve,reject) => {
                let img = await this.resolveImg();
                resolve(img)

            }).catch(e => {
                console.log('promise err > ', e);
            })
 */        },
    },
    computed: {
        ...mapState([
            'itemInLimbo','settings'
        ]),
        // showActions() {
        //     return  (!this.isThisitemInLimbo && !!this.actions && (this.type=='cart' || !this.item.inCart))
        // },
        // activeActions() {
        //     return !!this.isTouchDevice && !!this.showActionsOnDevices
        // },
        isThisitemInLimbo() {
            return !!this.itemInLimbo && this.itemInLimbo.id==this.item.id;
        },
        isTouchDevice() {
            return true
        },
        isIOSDevice() { return /iPad|iPhone|iPod/.test(window.navigator.platform)}
    }
}
</script>

<style>
    .item-preview .item-preview-image.item-small .item-actions .item-act-title {
        display: none;
    }
    .item-preview.item-small .label {
        color:#fff;
        /* display: none; */
        width: 100%;
        width: 140px;
        float: left; 
        padding-top: 15px;       
    }
    @media (hover: none) {
        .item-preview .item-preview-image .item-actions .action span {        
            display: none;
        }
    }

</style>
<style lang="stylus">
@import '~settings';
@import '~rupture';
.flyin
    opacity 1 !important
    /.no-touch &
        box-shadow inset 0px 0px 20px rgba(255,255,255,0.9) !important
 ::selection
    background lighten(blue, 43)
.item-flag
    pointer-events none
    position absolute 0 false false 0
    //top -5px
    //left -5px
    top 6px
    left calc(100% - 50px)
    overflow hidden
    z-index 29    
    border-radius 100%
    height auto
    /.no-touch &
        box-shadow 3px 3px 7px rgba(#000, 0.2), inset 2px 2px 10px rgba(#000, 0.5)
    img
        self-center()
        // width 100%
        min-width 100%
        max-height 100%
    /.huge-item &
        width 30%
        padding-bottom 30%
    /.big-item &
        width 20%
        padding-bottom 20%
    /.no-touch:not(.ie) & > img
        max-width 200%
        min-height 105%
.item-preview
    .label
        font-weight 100
        width calc(100% - 10px)
        text-align left
        margin 0 auto
        color rgba(#000, 0.7)
        padding-top 10px
        white-space normal
        div
            //font-size 13px
        div:first-child
            display block
            margin-bottom 3px

    .label_xxxxxx
        pointer-events none
        width calc(100% - 10px)
        text-align left
        margin 0 auto
        font-size 16px
        color rgba(#000, 0.7)
        white-space normal
        position absolute
        bottom 0px
        --background-color  rgba(0,0,0,0.5)
        background rgb(23,23,23)
        background linear-gradient(180deg, rgba(23,23,23,0) 0%, rgba(23,23,23,1) 100%)
        padding 15px 17px 15px 17px
        margin 0px 5px
        --border-radius 0px 0px 20px 20px
        color #fff
        +below(815px)
            width 90%
            font-size 14px
        span:first-child
            display block
            margin-bottom 5px
            &.item-mct
                //font-size 14px
        .item-name
            color lighten(#fff, 2)
            font-weight 400
            /.cart &
                color darken(#fff, 50)
    /.item-small + .item-act-title
        //display none
    .item-preview-image
        position relative
        background-position 50% 50%
        background-size 105%
        background-repeat no-repeat
        border-radius 15px
        //margin 0 auto
        background-color #f9f9f9
        //background-color darken(#2e2e2e, 5)
        /.no-touch &
            --box-shadow inset 2px 2px 8px rgba(0,0,0,0.2)
        transition border-radius 0.4s 
        &.bordermode-circle            
            border-radius 100%
        &.incart
            overflow hidden
            &:after
                content ''
                position  absolute 0 0 0 0
                background #212121
                opacity 0.8
        &.item
            &-big
                // width 274px
                // height @width
                width 96%
                padding-bottom 96%
                height auto
            &-huge
                width 394px
                height @width
                +below(1700px)
                    width 354px
                    height @width
                +below(1600px)
                    width 394px
                    height @width
                +below(1400px)
                    width 354px
                    height @width
                +below(1200px)
                    width 394px
                    height @width
            &-small
                width 140px
                height @width
                background-size 102%
        .item-info
            opacity 0
            transition opacity 0.5s ease-out-circ
            position absolute
            bottom 13%
            left 50%
            transform translateX(-50%)
            .info
                @extend $sharpen
                color rgba(#fff, 0.55)
                fontsizer(11px, 13px)
                font-weight 300
                div
                    display inline-block
                    padding 2px 0
                    &[contenteditable="true"]:focus
                        padding 0 4px
                        outline 1px dashed rgba(blue, 0.5)
                        background rgba(#fff, 0.8)
                        color darken(gray, 30)
                &:first-child
                    margin-bottom 3px
        .item--incart
            self-center()
            backface-visibility hidden
            .closebtn
                top 0
                left 50%
                right initial
                transform translate(-50%, -150%) scale(0.6)
            i.fas
                font-size 2.5vmin
                color #fff
                opacity 0.6
                display block
                margin 1vh auto
                backface-visibility hidden
                transition opacity 0.2s ease-out
            input
                display block
                background rgba(#121212, 0)
                border 0
                font-family arial
                width 100%
                height 36px
                line-height @height
                padding 0 4%
                font-size 44px
                color #01cefd
                border 1px solid rgba(blue, 0)
                border-radius 4px
                margin 1vh auto
                text-align center
                opacity 0.8
                backface-visibility hidden
                transition width 0.2s ease-out, border 0.2s ease-out, font-size 0.2s ease-out, background 0.2s ease-out, opacity 0.2s ease-out
                &:focus
                    border 1px solid rgba(blue, 0.8)
                    background rgba(#121212, 0.3)
                    font-size 18px
                    width 60%
            label
                opacity 0.6
                font-size 18px
                transform translateZ(0)
                backface-visibility hidden
                transition opacity 0.2s ease-out
            &:hover
                i
                    opacity 1
                input
                    border 1px solid rgba(blue, 0.8)
                    background rgba(#121212, 0.3)
                    font-size 18px
                    width 60%
                label
                    opacity 1

        .item-add
            self-center()
            width 80%
            .closebtn
                top 0
                self-center(horizontal)
                transform translate(-50%, -225%) scale(0.6)
            label
                font-size 16px
            input
                background rgba(#121212, 0.3)
                border 0
                width 100%
                height 36px
                line-height @height
                padding 0 4%
                font-size 16px
                color #01cefd
                margin-top 10px
                width 60%
                border 1px solid rgba(blue, 0.8)
                border-radius 4px
                text-align center
        .check--save
            display block
            width 6vmin
            height @width
            border-radius unit(@width/2, 'vmin')
            border 1px solid blue
            self-center(horizontal)
            bottom 0
            transform translate(-50%, 110%) scale(0.75)
            opacity 0.8
            transition opacity 200ms ease-out, transform 200ms ease-out
            z-index 999
            backface-visibility hidden
            &:hover
                opacity 1
                transform translate(-50%, 108%) scale(0.76)
            +below(1400px)
                transform translate(-50%, 140%) scale(0.75)
                &:hover
                    opacity 1
                    transform translate(-50%, 138%) scale(0.76)

        .checkbtn
            self-center()
            transform translate(-50%, -60%) rotate(40deg) scale(0.6)
            border-color blue

        .item-actions
            z-index 10
            @extend $inline-mid
            opacity 0
            background rgba(#1178be, 0.9)
            position absolute 0 0 0 0
            transform scale(1.01)
            transition opacity 0.5s ease-out-circ
            text-align center
            pointer-events none
            border-radius 15px
            &.bordermode-circle
                border-radius 100%
            &.bordermode-circle
                .item-act-title
                    display none

            .item-act-title
                position absolute
                top 0px
                left 0px
                width 100%
                padding 20px
                --background red
                text-align left
                //font-size 14px
                +below(815px)
                    display none
            .action
                @extend $absolute-mid
                position relative
                background transparent
                border-radius 50%
                margin 0 2.5%
                border 2px solid #fff
                text-align center
                color #fff
                cursor pointer
                i
                    color #fff
                /.item-big .action
                    fontsizer(18px, 22px)
                    width 22%
                    padding-top 20%
                /.item-huge .action
                    fontsizer(18px, 28px)
                    width 21%
                    padding-top 20%
                /.item-small .action
                    fontsizer(12px, 16px)
                    width 28%
                    padding-top 25%
                span
                    // @extend $sharpen
                    opacity 0
                    position absolute
                    bottom -25px
                    left 50%
                    transform translateX(-50%)
                    text-transform uppercase
                    font-size 12px
                    white-space nowrap
                    +below(815px)
                        display none
                /.active span
                    opacity 1 !important
                    // transition opacity .3s ease-out
                &::first-child
                    margin-left 0
                &::last-child
                    margin-right 0
                &:hover
                    i
                        color #03c6f3
                    span
                        opacity 1
        &.active
        &.incart
            .item-actions, .item-info
                pointer-events initial
                opacity 1
                z-index 2
                background rgba(#2e2e2e, 1)
            &:after
                z-index 1
        /.no-touch &:hover:not(.incart)
                .item-actions, .item-info
                    pointer-events initial
                    opacity 1
</style>